import { AccountData } from "services/management-backend/client";

/**
 * @typedef {Object} Account
 * @property {number} id
 * @property {number} organizationId
 * @property {string} name
 * @property {string} number
 * @property {boolean} isAdhoc
 * @property {number} brandId
 */
type Account = {
  id: number;
  organizationId: number;
  name: string;
  number: string;
  isAdhoc: boolean;
  brandId: number;
};

/**
 * Converts a AccountData DTO to an Account
 *
 * @param {AccountData} dto
 * @returns {Account} account
 */
export function dtoToAccount(dto: AccountData): Account {
  return {
    id: dto.id,
    organizationId: dto.org_id,
    name: dto.name,
    number: dto.number,
    isAdhoc: dto.is_adhoc,
    brandId: dto.brand_id,
  } satisfies Account;
}

export default Account;
